"use strict";

exports.__esModule = true;
exports.filterDataProps = void 0;
const acceptedPropsStart = 'data-';
const filterDataProps = props => {
  const output = {};
  for (const key in props) {
    if (props.hasOwnProperty(key) && key.length > acceptedPropsStart.length && key.startsWith(acceptedPropsStart)) {
      output[key] = props[key];
    }
  }
  return output;
};
exports.filterDataProps = filterDataProps;
//# sourceMappingURL=FilterDataProps.js.map